import { AnyAction, combineReducers, Reducer } from "@reduxjs/toolkit";
// import { connectRouter } from 'connected-react-router';
import { createReduxHistoryContext } from 'redux-first-history';
import { BrowserHistory } from "../Utils/BrowserHistory";
import providerReducer, { providerActions } from "./Provider/reducer";
import patientsReducer from "./Patients/reducer";
import { RootState } from ".";
import storage from "redux-persist/lib/storage";
import orderReducer from "./Order/reducer";
import alertReducer from "./Alerts/reducer";
import tempReducer from "./TempStore/reducer";

const { routerReducer } = createReduxHistoryContext({ 
  history: BrowserHistory,
  //other options if needed 
});

const allReducer = combineReducers({
  router: routerReducer,
  tempState: tempReducer,
  provider: providerReducer,
  patients: patientsReducer,
  orders: orderReducer,
  alert: alertReducer,
});

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === providerActions.logout.type) {

    // this applies to all keys defined in persistConfig(s)
    storage.removeItem('persist:root');

    state = {} as RootState
  }
  return allReducer(state, action)
}

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
